export default "<template>\n\n  <KTextbox\n    label=\"Text area\"\n    textArea\n  />\n\n</template>\n";